/** Works on mobile HTTP / older WebViews where crypto.randomUUID is missing. */
export function generateId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    try {
      return crypto.randomUUID();
    } catch {
      /* secure context or platform may block randomUUID */
    }
  }
  return `id-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
